import { api } from ".."
import { featureFlagsURL } from "../../../api"
import { FeatureFlagsResponse } from "./types"

export const featureFlags = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchFeatureFlags: builder.query<FeatureFlagsResponse[], void>({
      query: () => ({ url: featureFlagsURL() }),
      providesTags: ["FeatureFlags"],
    }),
  }),
})

export const { useFetchFeatureFlagsQuery, useLazyFetchFeatureFlagsQuery } =
  featureFlags
